import * as firebase from 'firebase'
// import 'firebase/firestore'

// Initialize Firebase
export const config = {
	"apiKey": "AIzaSyBPWCg3FqN1MQaI5qY13ItxRfmYRQ4xi70",
	"databaseURL": "https://options4all-ce06e.firebaseio.com",
	"authDomain": "options4all-ce06e.firebaseapp.com",
	"projectId": "options4all-ce06e",
	"appId": "1:193860347203:web:d29105d32790b18e",
	"storageBucket": "gs://options4all-ce06e.appspot.com",
	"messagingSenderId": "193860347203"
};

firebase.initializeApp(config);

firebase.firestore().settings({
  cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED
});

firebase.firestore().enablePersistence()

// db.settings({ timestampsInSnapshots: true });

// make auth and firestore references
// export const db = firebase.firestore();
// export const auth = firebase.auth();
// export const functions = firebase.functions();
// export const storage = firebase.storage();

// update firestore settings
// db.settings({ timestampsInSnapshots: true });

export default firebase